module.exports = __webpack_public_path__ + "media/images/LED-2-e2b6e1b2b191aea04afa8bfcf8e7b65e.png";